// extracted by mini-css-extract-plugin
export default {"spacer":"Card_spacer__2r4Vy","removeMyCardButton":"Card_removeMyCardButton__rtVX9","alert":"Card_alert__PlBo2","dialog":"Card_dialog__7JxBA","buttonGroup":"Card_buttonGroup__Ppxyk"};